// ============================================================================
// Browser-history write seam
// ============================================================================
//
// The future TanStack browser history observes raw window.history writes.  A
// direct replaceState outside this seam would therefore create a second
// navigation authority after the root cutover.  Keep the one pre-render hash
// compatibility rewrite here; mounted code must use the navigation facade.
// ============================================================================

export type BrowserHistoryWriter = {
  replaceState: (data: unknown, unused: string, url?: string | null) => void;
};

/**
 * Perform one declared low-level browser-history replacement.
 *
 * Callers deliberately inject the History-like capability so bootstrap stays
 * testable without a DOM.  In B2 there are exactly two approved callers:
 * runtimeInit's pre-render hash rewrite and B3's React-Router-state handoff.
 * The latter uses a native writer captured before TanStack wraps History, so
 * it migrates state shape without publishing a second application navigation.
 * No caller outside app/navigation may call replaceState directly.
 */
export function replaceBrowserHistoryState(history: BrowserHistoryWriter, state: unknown, url: string): void {
  history.replaceState(state, '', url);
}
